(function () {

  let navToggle = document.getElementById('nav-toggle'); 
  let siteNavigation = document.getElementById('site-navigation');

  navToggle.addEventListener('click', function (e) {
    e.stopPropagation();
    document.body.classList.toggle('menu-open');
    var x = 'true' == navToggle.getAttribute('aria-expanded') ? 'false' : 'true';
    navToggle.setAttribute('aria-expanded', x);
  })

  // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
  document.addEventListener('click', function (e) {
    if (!siteNavigation.contains(e.target)) {
      document.body.classList.remove('menu-toggled');
      navToggle.setAttribute('aria-expanded', 'false');
    }
  });

  //desktop
  // toggle sub-menu solutions when one is open , the other close.
  let custom_menu = document.querySelectorAll(".sub-menu-item-custom");
  let a_items = document.querySelectorAll(".sub-menu-item-custom >  .li-wrap");

  for (let i = 0; i < custom_menu.length; i++) {
    if(typeof a_items[i] != 'undefined'){
      a_items[i].addEventListener('click', function (e) {
        let current = this.parentElement;
        for (var i = 0; i < custom_menu.length; i++) {
          if (current != custom_menu[i]) {
              custom_menu[i].classList.remove('active');
          } else if (current.classList.contains('active') === true) {
              current.classList.remove('active');
          } else {
              current.classList.toggle('active');
          }
        }
        e.preventDefault()

      });
    }
  }

  //mobile main menu toggle
  let nav_item = document.querySelectorAll(".nav-item");
  let a = document.querySelectorAll(".nav-item > .li-wrap");

  for (let i = 0; i < nav_item.length; i++) {
    if (typeof a[i] != 'undefined'){
      a[i].addEventListener('click', function (e) {
        e.preventDefault();

        /**enlever class active quand open-submenu  */
        for (var k = 0; k < custom_menu.length; k++) {
          custom_menu[k].classList.remove('active');
        }

        let current = this.parentElement;
          
        for (var i = 0; i < nav_item.length; i++) {
          if (current != nav_item[i]) {
            nav_item[i].classList.remove('open-submenu');
          } else if (current.classList.contains('open-submenu') === true) {
              current.classList.remove('open-submenu');
          } else {
              current.classList.toggle('open-submenu');
          }
        }
      });
    }  
  }

  //mobile smenu-footer toggle
  let nav_items = document.querySelectorAll(".nav-item");
  let a_item = document.querySelectorAll(".nav-item > a");

  for (let i = 0; i < nav_items.length; i++) {
    if(typeof a_item[i] != 'undefined'){
      a_item[i].addEventListener('click', function (e) {
        let current = this.parentElement;
        e.preventDefault();

        for (var i = 0; i < nav_items.length; i++) {
          if (current != nav_items[i]) {
            nav_items[i].classList.remove('open-submenu');
          } else if (current.classList.contains('open-submenu') === true) {
            current.classList.remove('open-submenu');
          } else {
            current.classList.toggle('open-submenu');
          }
        }          
      });
    }  
  }


  /** animation SVG **********************************************************************************************/
  let animate = document.querySelectorAll('.animated-svg');
  var observer = new IntersectionObserver(function (entries) {
    for (let i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting === true) {
        entries[i].target.classList.add('onscreen');
      }
    }
  }, { threshold: [1] });

  animate.forEach(el => {
    observer.observe(el);
  });

})()

/** acf avantage tab */
jQuery(document).ready(function ($) {
  //YOUR JQUERY CODE
  let idMenu;
  let acc_current = $("h4.acc-open").attr('id');

  if ($('body').hasClass('home')) {
    $('html').addClass('html-front-page');
  }

  /**front-page */

  $.each( $('.banners-home .banner'), function(index, val) {
    $(this).on('click',  function(event) {
      //event.preventDefault();
      $('.banners-home .banner').removeClass('active');
      $(this).addClass('active');
        
      if (idMenu == $(this).attr('id') ){
        $('#'+idMenu).find('.content').animate({left: '-100%'}, 100,function(){
          $('.banners-home .banner').removeClass('active');
        });
        idMenu = '';
      } else {
        idMenu = $(this).attr('id');
        $('.banners-home .banner .content').animate({left: '-100%'}, 100,function(){
          $('#'+idMenu).find('.content').animate({left: 0}, 300); 
        });//end animate
      }
        
    });//end on click
  });//end each

  $('.close').on('click', function(event) {
    event.preventDefault();
    $(this).parent().parent().animate({left: '-100%'}, 100,function(){
      $('.banners-home .banner').removeClass('active');
    });
  });/**/

  /********end front-page */

  $('.accordeon h4').on('click', function (event) {
    event.preventDefault();
    /* Act on the event */
    let el = jQuery(this);
    let id_current = el.attr('id');
  
    if ($('.accordeon > ul:visible').length > 0 && id_current != acc_current) {
      $('.accordeon > ul:visible').prev().removeClass('acc-open');
      $('.accordeon > ul:visible').slideToggle(function () {
        acc_current = id_current;
      });  
    } 

    if (acc_current != id_current) {
      el.addClass("acc-open");
      el.next().slideToggle(function () {
        acc_current = id_current;
      });
    } else {
      el.removeClass("acc-open");
      el.next().slideToggle(function () {
        acc_current = "";
      });
    }
  });

});


/************************************************************************************************************************************************************* */
//GOOGLE MAP API
var map;
function initialize() {
  // Map Style JSON
     
  var blueStyle = [
    {
      'featureType': 'all',
      'elementType': 'labels',
      'stylers': [{'visibility': 'off'}]
    }, 
    {
      'featureType': 'road',
      'elementType': 'labels.icon',
      'stylers': [{'visibility': 'off'}]
    }, 
    {
      'stylers': [
        {
          'hue': '#00aaff',
          'saturation': -50,
          'gamma': 1.15,
          'lightness': 12
        }
      ]
    }, 
    {
      'featureType': 'landscape',
      'elementType': 'labels.text.fill',
      'stylers': [
        {
          'visibility': 'on',
          'lightness': 24
        }
      ]
    }, 
    {
      'featureType': 'road',
      'elementType': 'geometry',
      'stylers': [{'lightness': 85}]
    }
  ];
   
  var c = new google.maps.LatLng(45.443458,-73.444502);
  var mapOptions = {
    zoom:14,
    center: c,
    styles: blueStyle,
    disableDefaultUI: true,
    sensor: true
  };

  //marker
  var icon = {
    url: '/wp-content/themes/planitou/assets/images/map-marker.png', // url
    scaledSize: new google.maps.Size(25, 25), // scaled size
    origin: new google.maps.Point(0,0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };

  var marker = new google.maps.Marker({
      position: c,
      title:'planitou',
      icon:icon,
      animation:google.maps.Animation.BOUNCE,
      optimized:false
  });

  map = new google.maps.Map(document.getElementById('map'), mapOptions);
  marker.setMap(map);   
}

/**end google map API */
function loadScript() {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyDnGB5Xe2oqvown7cMEroHN_lDFTwTBmmk&callback=initialize';
  document.body.appendChild(script);
}

if(document.getElementById('map')){
  window.onload = loadScript;   
}
 

/** nav bar visible/hidden on scroll ************************************************************************************/

jQuery(window).ready(function ($) {
  var $window = $(window);
  var y = 0;
  $window.scroll(function(){
    if (Math.abs($window.scrollTop()- y) > 20){
      y = $window.scrollTop();
    };

    if($window.width() >= 1200){
      if($window.scrollTop() - y > 5) {
        $(".site-header").addClass('hidden');
      } else {
        $(".site-header").removeClass('hidden');
      }   
    }
  });
});
